export default __webpack_public_path__ + "static/media/main-image.76c652d0.png";